// People's profile photos for avatars, fetched once each with the session
// (GET /api/people/:id/photo) and kept as object URLs while the app is open.
import { useEffect, useState } from 'react';

import { authenticatedFetch } from '../auth/authClient';
import { fetchPhoto } from './workApi';

const cache = new Map<string, Promise<string | null>>();

/** Object URLs by person id, for the people who have a photo. */
export function usePhotos(people: readonly { id: string; has_photo: boolean }[]): Map<string, string> {
  const [urls, setUrls] = useState<Map<string, string>>(new Map());
  const wanted = people.filter((p) => p.has_photo).map((p) => p.id).sort().join(',');
  useEffect(() => {
    let live = true;
    const ids = wanted ? wanted.split(',') : [];
    void Promise.all(ids.map(async (id) => {
      if (!cache.has(id)) cache.set(id, fetchPhoto(authenticatedFetch, id).catch(() => null));
      return [id, await cache.get(id)!] as const;
    })).then((pairs) => {
      if (live) setUrls(new Map(pairs.filter((p): p is readonly [string, string] => p[1] !== null)));
    });
    return () => {
      live = false;
    };
  }, [wanted]);
  return urls;
}
